class VideoGallery {
  constructor(el) {
    this.el = el;
    this.players = this.el.querySelectorAll('.video-gallery__player');
    this.buttons = this.el.querySelectorAll('.video-gallery__btn');

    this.players.forEach((player) => {
      const media = player.querySelector('.video-gallery__media');
      media.addEventListener('click', () => this.play(player, media));
    });

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(Number(button.dataset.index)));
    });
  }

  play(player, media) {
    if (player.querySelector('iframe')) return;

    const iframe = document.createElement('iframe');
    iframe.src = media.dataset.embed;
    iframe.title = media.dataset.title || '';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.className = 'video-gallery__iframe';

    media.replaceWith(iframe);
    player._media = media;
  }

  // Al cambiar de video se para el anterior restaurando la portada
  stop(player) {
    const iframe = player.querySelector('iframe');
    if (iframe && player._media) {
      iframe.replaceWith(player._media);
    }
  }

  select(index) {
    this.players.forEach((player) => {
      const isActive = Number(player.dataset.index) === index;
      if (!isActive) this.stop(player);
      player.classList.toggle('is-active', isActive);
    });

    this.buttons.forEach((button) => {
      const isActive = Number(button.dataset.index) === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const activePlayer = this.el.querySelector('.video-gallery__player.is-active');

    // En mobile el player queda fuera de pantalla al pulsar la lista
    if (window.matchMedia('(max-width: 991px)').matches) {
      activePlayer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

document.querySelectorAll('.js-video-gallery').forEach((el) => new VideoGallery(el));
